export type BusinessType = "B2B" | "B2C";

export enum AirshipFeature {
  Push = "push",
  TagsAndAttributes = "tags_and_attributes",
  Contacts = "contacts",
  FeatureFlags = "feature_flags",
  Analytics = "analytics",
}

export const ALL_FEATURES = Object.values(AirshipFeature);

export interface AirshipConfig {
  appKey: string;
  token: string;
  vapidPublicKey: string;
}

export interface AirshipLoaderProps extends AirshipConfig {
  hasPushConsent: boolean;
  hasTrackingConsent: boolean;
  userId?: string;
  brand: string;
  businessType: BusinessType;
}

export interface AirshipSDK {
  create: () => Promise<void>;
  register: () => Promise<{ channelId: string }>;
  canRegister: () => Promise<boolean>;
  privacyManager: {
    enable: (...features: AirshipFeature[]) => Promise<void>;
    disable: (...features: AirshipFeature[]) => Promise<void>;
    listEnabled: () => Promise<string[]>;
  };
  contact: {
    identify: (userId: string) => Promise<void>;
    reset: () => Promise<void>;
  };
  channel: {
    id: () => Promise<string>;
    optedIn: () => Promise<boolean>;
    optOut: () => Promise<boolean>;
  };
}

declare global {
  interface Window {
    UA?: Promise<AirshipSDK>;
    airshipSDK?: AirshipSDK;
  }
}
